import {lightTheme} from '../../components/style';

const initialState = lightTheme()

const themeReducer = (state = initialState, action: any) => {
switch (action.type) {
    case 'CHANGE_THEME': {
    
        return action.payload
    }
    default: {
        return state
    }
}
}

export default themeReducer